import React, { Component } from "react";
import Stserviceitems from "./StserviceItem";
import Reveal from "react-reveal/Reveal";
class Sservice extends Component {
  render() {
    return (
      <section className="agency_service_area bg_color">
        <div className="container">
          <h2
            className="f_size_30 f_600 t_color3 l_height40 text-center mb_90 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            Values
          </h2>
          <div className="row mb_30">
            <div className="col-lg-4 col-sm-6 mb-5">
              <Reveal effect="fadeInUp" duration={1100}>
                <Stserviceitems
                  iShap="icon_shape1.png"
                  Sicon="ti-user"
                  text="Our People"
                  description="By fostering teamwork, nurturing talent, enhancing leadership capability & acting with pace, pride, & passion."
                //   btn="Read More"
                //   bicon="arrow_right"
                />
              </Reveal>
            </div>
            <div className="col-lg-4 col-sm-6 mb-5">
              <Reveal effect="fadeInUp" duration={1400}>
                <Stserviceitems
                  iShap="icon_shape2.png"
                  Sicon="ti-angle-double-down"
                  text="Our Offer"
                  description=" By becoming the supplier of choice, delivering premium products & services & creating value for our customers."
                //   btn="Read More"
                //   bicon="arrow_right"
                />
              </Reveal>
            </div>
            <div className="col-lg-4 col-sm-6 mb-5">
              <Reveal effect="fadeInUp" duration={1700}>
                <Stserviceitems
                  iShap="icon_shape3.png"
                  Sicon="ti-tag"
                  text="Our Innovative Approach"
                  description="By developing leading edge solution in technology, process & products."
                //   btn="Read More"
                //   bicon="arrow_right"
                />
              </Reveal>
            </div>
            <div className="col-lg-6 col-sm-6 mb-5">
              <Reveal effect="fadeInUp" duration={1700}>
                <Stserviceitems
                  iShap="icon_shape1.png"
                  Sicon="ti-medall"
                  text="Our Conduct"
                  description="By providing a safe workplace, respecting the environment caring for our communities & demonstrating high ethical standards."
                //   btn="Read More"
                //   bicon="arrow_right"
                />
              </Reveal>
            </div>
            <div className="col-lg-6 col-sm-6 mb-5">
              <Reveal effect="fadeInUp" duration={1700}>
                <Stserviceitems
                  iShap="icon_shape2.png"
                  Sicon="ti-camera"
                  text="Quality Vision"
                  description="We aspire to be the most trusted & preferred supplier of choice to our valuable customers."
                //   btn="Read More"
                //   bicon="arrow_right"
                />
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Sservice;
